/**
 * 完全公開 著作権・コンテンツ承認モーダル
 * SYSTEM_DESIGN.md §3.2 準拠
 */
export function promptConsent(): Promise<boolean> {
  return new Promise((resolve) => {
    const modalRoot = document.getElementById('modal-root')!;
    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay active';

    overlay.innerHTML = `
      <div class="modal-dialog" role="dialog" aria-modal="true" aria-labelledby="consent-title">
        <div class="modal-header">
          <div class="modal-title" id="consent-title">
            <span>🌐</span>
            <span>「完全公開」に関する権利・規約の確認</span>
          </div>
        </div>
        <div class="modal-body">
          <p style="margin-bottom: 16px; font-size: 13px; color: var(--color-text-secondary); line-height: 1.5;">
            完全公開に設定すると、授業内だけでなく誰でもアクセス可能な<strong>「公開ライブラリ」</strong>にあなたの作品が掲載されます。<br>
            公開前に、以下の3項目をすべて確認・同意してください。
          </p>

          <div style="display: flex; flex-direction: column; gap: 14px; background: #fafbfc; border: 1px solid var(--color-border); border-radius: 8px; padding: 16px; margin-bottom: 12px;">
            <label style="display: flex; align-items: flex-start; gap: 10px; cursor: pointer; font-size: 13px; line-height: 1.4;">
              <input type="checkbox" id="consent-check-1" style="margin-top: 3px; accent-color: var(--color-primary);" />
              <span>本作品に含まれるプログラム、画像、音声等のすべての素材は、第三者の<strong>著作権、意匠権、肖像権等を侵害していない</strong>ことを確認しました。</span>
            </label>

            <label style="display: flex; align-items: flex-start; gap: 10px; cursor: pointer; font-size: 13px; line-height: 1.4;">
              <input type="checkbox" id="consent-check-2" style="margin-top: 3px; accent-color: var(--color-primary);" />
              <span>公序良俗に反する内容や、<strong>他人を不快にさせるコンテンツ、個人情報を含んでいない</strong>ことを確認しました。</span>
            </label>

            <label style="display: flex; align-items: flex-start; gap: 10px; cursor: pointer; font-size: 13px; line-height: 1.4;">
              <input type="checkbox" id="consent-check-3" style="margin-top: 3px; accent-color: var(--color-primary);" />
              <span>インターネット上の誰からでも閲覧可能な<strong>「公開ライブラリ」に掲載されることに同意</strong>します。</span>
            </label>
          </div>
        </div>
        <div class="modal-footer">
          <button id="btn-consent-cancel" class="btn btn-text" type="button">キャンセル（限定公開のまま）</button>
          <button id="btn-consent-submit" class="btn btn-primary" type="button" disabled>同意して完全公開にする</button>
        </div>
      </div>
    `;

    modalRoot.appendChild(overlay);

    const check1 = overlay.querySelector('#consent-check-1') as HTMLInputElement;
    const check2 = overlay.querySelector('#consent-check-2') as HTMLInputElement;
    const check3 = overlay.querySelector('#consent-check-3') as HTMLInputElement;
    const submitBtn = overlay.querySelector('#btn-consent-submit') as HTMLButtonElement;

    const updateSubmitState = () => {
      submitBtn.disabled = !(check1.checked && check2.checked && check3.checked);
    };

    check1.addEventListener('change', updateSubmitState);
    check2.addEventListener('change', updateSubmitState);
    check3.addEventListener('change', updateSubmitState);

    const cleanup = () => {
      overlay.classList.remove('active');
      setTimeout(() => {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }, 200);
    };

    submitBtn.addEventListener('click', () => {
      cleanup();
      resolve(true);
    });

    overlay.querySelector('#btn-consent-cancel')!.addEventListener('click', () => {
      cleanup();
      resolve(false);
    });
  });
}
